'use strict';

var styleClasses = {"standard":"standard__Id3oj","disabled":"disabled__vMSrC","switch-container":"switch-container__-6nTx","switch-container--dot":"switch-container--dot__AI47q","switch-label":"switch-label__dx8Vt","small":"small__kG7Jg","medium":"medium__ZNGfZ","large":"large__dxHWz","top":"top__vmgIR","bottom":"bottom__VENm7","left":"left__NGlwz","checked":"checked__5t6X7","no-label":"no-label__GxHAR","right":"right__ywMM4"};

module.exports = styleClasses;
//# sourceMappingURL=standard-switch.module.scss.js.map
